import { useMemo } from "react";
import { Stop } from "@app/shared/models/tour.type";
import { decompress } from "@app/features/map/stop-details/StopDetails";


export const extractStopLinks = (activeStop?: Stop, title: string = "") => {
    return useMemo(() => {
        if (!activeStop?.all_media) return [];
        let buttonDivs: { title: string; html: string; name: string }[] = [];
        activeStop.all_media.forEach((media) => {
            if (media.type?.includes("html")) {
                let htmlContent = "";
                try {
                    htmlContent = decompress(media?.content as string);
                } catch (err) {
                    htmlContent = media?.content as string;
                }
                const parser = new DOMParser();
                const doc = parser.parseFromString(htmlContent, "text/html");
                const foundDivs = Array.from(doc.querySelectorAll("div")).filter((div) => div.querySelector("a"));
                buttonDivs = buttonDivs.concat(
                    foundDivs.map((div) => ({
                        title,
                        html: div.outerHTML,
                        name: media.name,
                    }))
                );
            }
        });
        return buttonDivs;
    }, [activeStop, title]);
}